import { ItemListMapper } from '../../infrastructure/utils/implementation/item-list.mapper';
import { IDeliveryItemDetailsDTO } from '../../api/events.dao';

export class DeliveryTeamMemberItemsMapper extends ItemListMapper<IDeliveryItemDetailsDTO> {
    public static create(initialDeliveryTeamMemberList: IDeliveryItemDetailsDTO[]): DeliveryTeamMemberItemsMapper {
        return new DeliveryTeamMemberItemsMapper(initialDeliveryTeamMemberList || []);
    }

    public getAddedDeliveryTeamMembersToList(list: IDeliveryItemDetailsDTO[]): IDeliveryItemDetailsDTO[] {
        return super.getItemsAddedToList(list, this.initialList);
    }
    public getRemovedDeliveryTeamMembersFromList(list: IDeliveryItemDetailsDTO[]): IDeliveryItemDetailsDTO[] {
        return super.getItemsRemovedFromList(list, this.initialList);
    }
    public getUpdatedDeliveryTeamMembersInList(list: IDeliveryItemDetailsDTO[]): IDeliveryItemDetailsDTO[] {
        return super.getItemsUpdatedInListByKey(list, this.initialList, this.updateKey);
    }

    private constructor(private readonly initialList: IDeliveryItemDetailsDTO[]) {
        super('username');
    }

    private readonly updateKey = 'deliveryTeamMemberRole';
}
